<template>
  <span class="iai-tag" :class="[variantClasses[variant], sizeClasses[size], roundedSideClasses[roundedSide]]">
    <slot></slot>
  </span>
</template>

<script setup lang="ts">
type TagVariant = "primary" | "disabled" | "default" | "pink" | "green";
type TagSize = "small" | "large";
type RoundedSideVariant = "left" | "right" | "both";

const props = withDefaults(
  defineProps<{
    variant?: TagVariant;
    size?: TagSize;
    roundedSide?: RoundedSideVariant;
  }>(),
  {
    variant: "primary",
    size: "small",
    roundedSide: "both",
  }
);

const variantClasses = {
  primary: "bg-theme-3 text-white",
  disabled: "bg-theme-disabled-b text-white",
  default: "bg-theme-placeholder-bg text-theme-1",
  pink: "bg-theme-3 text-white",
  green: "bg-theme-success-b text-theme-1",
} as const;

const sizeClasses = {
  small: "rounded-[4px] px-2 py-0.5 text-xs",
  large: "rounded-md px-5 py-2 text-sm",
} as const;

const roundedSideClasses = {
  left: "rounded-l-[4px] rounded-r-none",
  right: "rounded-r-[4px] rounded-l-none",
  both: "",
} as const;
</script>

<style scoped lang="scss">
.iai-tag {
  @apply cursor-default whitespace-nowrap;
}
</style>
